import { render, staticRenderFns } from "./ChoujianList.vue?vue&type=template&id=b2d0dbc6&scoped=true"
import script from "./ChoujianList.vue?vue&type=script&lang=js"
export * from "./ChoujianList.vue?vue&type=script&lang=js"
import style0 from "./ChoujianList.vue?vue&type=style&index=0&id=b2d0dbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d0dbc6",
  null
  
)

export default component.exports